import * as React from 'react';

function SvgExclamationLg(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M6.002 14a2 2 0 114 0 2 2 0 01-4 0zm.195-12.01a1.81 1.81 0 113.602 0l-.701 7.015a1.105 1.105 0 01-2.2 0l-.7-7.015z' />
		</svg>
	);
}

export default SvgExclamationLg;
